import React from "react";
import CustomCard from "./Card";
import BioCard from "./Bio";
import "./Projects.css";

export default function Projects() {
  const cardContents = [
    {
      title: "Epic Systems Software Engineering Internship",
      description:
        "Built a Body System Avatar for inpatient nurses to visualize patient state",
      body: "Developed an avatar to visualize patient body systems for use by inpatient nurses. Implemented a React-based frontend and a C# webserver backend to visualize patient data securely and clearly. Collaberated with UX designers, Epic's internal clinicians, and client stakeholders to iterate on the product and deliver a polished experience for nurses.",
    },
    {
      title: "Boston College Remote Sensing Lab",
      description:
        "Led software engineering and applied remote sensing research for mobile delivery of grazing intelligence in Kenya",
      body: `Served as Lead Software Engineer and Researcher and became first author on an IEEE GHTC conference paper. Architected backend infrastructure for a mobile app that delivers satellite-sourced grazing data to pastoralists in Kenya. Leveraged the Google Earth Engine geospatial API to provide on-demand access through SMS connectivity. Compressed NDVI polygon datasets to 2% of original size without data loss to enable reliable access in remote, low-bandwidth environments.`,
      link: "https://github.com/H-137/Summer-2025-Kenya",
    },
    {
      title: "Study at BC",
      description:
        "Built an interactive full-stack web app that matches students to on-campus study locations",
      body: `Designed and shipped the full product experience, from discovery and filtering to location/review submission. Implemented a MongoDB-backed data model so students can add new study spots and reviews in real time. Iterated on layout and filtering behavior using direct student feedback to improve speed and usability.`,
      link: "https://study.matt-leopold.com",
    },
    {
      title: "Climate Delta (HTH25)",
      description:
        "Built an interactive climate insights web app to visualize local climate trends and forecasts",
      body: `Developed core product features with Next.js, React, and TypeScript, and styled responsive views with Tailwind CSS. Integrated data from a varity of public weather data sources to provide insights into temperature, rainfall, land use. In addition, implemented a time series forcasting model to provide users with future temperature predictions based on historical trends. Presented the product and technical approach to hackathon judges and attendees.`,
      link: "https://github.com/H-137/HTH25",
    },
    {
      title: "Project Parking (HTH24",
      description:
        "Built a hackathon full-stack app that detects open parking and routes users to the closest available spot",
      body: `Implemented OpenCV-based image classification to label parking spaces as open or occupied, then connected results to Google Maps routing for turn-by-turn navigation. Integrated destination-aware matching logic to prioritize nearest viable lots. Presented the solution and technical approach directly to hackathon judges.`,
      link: "https://devpost.com/software/project_parking",
    },
    {
      title: "Feta (Hatchery Management System)",
      description:
        "Built a makerspace management system prototype for the Boston College Hatchery",
      body: `Implemented backend features in Django and Python for booking workflows, credential tracking, and availability management, with SQLite as the persistence layer. Built frontend pages and interactions using Django templates, HTML, CSS, and JavaScript to support dashboard, scheduling, and reporting use cases. Integrated Google OAuth via django-allauth and improved role-based access flows for BC users.`,
      link: "https://github.com/CSCI3356-Fall2025/Feta",
    },
    {
      title: "Bridge2AI Summer Program",
      description:
        "Built and validated voice de-identification models in a cross-functional AI research program",
      body: `Collaborated with computer scientists and medical students at Weill Cornell Medicine to prototype ML pipelines for voice-as-biomarker workflows. Built and evaluated a voice de-identification approach and validated outcomes with a KNN-based verification model. Delivered results under hackathon-style timelines while coordinating across a multidisciplinary team.`,
      link: "https://eipm.weill.cornell.edu/news/welcome-inaugural-bridge-2ai-voice-summer-school-class",
    },
    {
      title: "Arduino LED Lighting System",
      description:
        "Engineered a custom Arduino + DMX LED control system from reused theater hardware",
      body: `Designed and assembled an end-to-end hardware/software lighting system using LED strips, a DMX controller, and an Arduino with DMX hat. Built the enclosure and control interface with physical buttons and potentiometer input for live color control. Delivered a reliable installation by integrating power, wiring, and embedded control logic.`,
    },
    {
      title: "Sudoku Solver",
      description: "Developed a C-based Sudoku solver using depth-first search",
      body: `Implemented a performant search-based solver in C and optimized board traversal logic for speed. Benchmarked against a Python implementation and achieved roughly 10x faster runtime on equivalent puzzles. Used low-level memory control to keep the implementation efficient and predictable.`,
      link: "https://github.com/H-137/Sudoku",
    },
    {
      title: "C Memory Allocator",
      description: "Implemented a malloc/free-style allocator in C for heap management",
      body: `Built a custom allocator that manages heap blocks, allocation, and de-allocation with explicit low-level memory bookkeeping. Debugged fragmentation and pointer-handling edge cases to maintain correctness. Gained deep systems-level understanding of memory lifecycle behavior in C programs.`,
      link: "https://github.com/H-137/Malloc-clone",
    },
  ];

  return (
    <main className="projects">
      <BioCard />
      <section className="projects-section">
        <h2>Projects</h2>
        <ul className="project-list">
          {cardContents.map((project) => (
            <CustomCard key={project.title} {...project} />
          ))}
        </ul>
      </section>
      <footer>
        <p>© 2026 Matthew Leopold</p>
      </footer>
    </main>
  );
}
